<template>
  <PopModal ref="modal" :is-large="true" :title="$t('申请提款')">
    <div class="container pa-3">
      <van-field :label="$t('钱包余额')" prop="type">
        <template #input>
        <zselect
            v-model="formObj.type"
            classname="EnumAccountType"
            :placeholder="$t('余额类型')"
            :default-first="true"
            :filter-fun="filterWithdrawType"
        />
        </template>
      </van-field>
      <el-alert type="success" class="">
        <span class="bold u-font-16">{{ $t('您的钱包余额') }}：{{ formatMoney(balance, currency, true) }}</span>
      </el-alert>
<!--      <div class="card bg-template bg-blue">-->
<!--        <div class="card-body">-->
<!--          <div class="row justify-center pl-2 pr-2">-->
<!--            <div class="text-center">-->
<!--              <div-->
<!--                  v-if="formObj.type === 'BALANCE'"-->
<!--                  class="mb-0 font-weight-normal ft-26"-->
<!--              >-->
<!--                {{ formatMoney(userMoney.balance, currency, true) }}-->
<!--              </div>-->
<!--              <div-->
<!--                  v-if="formObj.type === 'COMMISSION'"-->
<!--                  class="mb-0 font-weight-normal ft-26"-->
<!--              >-->
<!--                {{ formatMoney(userMoney.balance2, currency, true) }}-->
<!--              </div>-->
<!--              <p class="text-mute">{{ $t("Balance") }}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="card">
        <div class="">
          <div class="row">
            <template v-if="washMoneyOpen">
              <div class="col-5 text-secondary small mb-2">
                {{ $t("Wash_Money") }}
              </div>
              <div class="col-7 small">{{ userMoney.washMoney }}</div>
            </template>
            <van-field v-if="userInfo.phone" :label="$t('手机号码')" class="cell-item mt-2">
              <template #input>
                <div class="wallet-info d-flex flex-full">
                  <span class="text">{{ userInfo.phone }}</span>
                </div>
              </template>
            </van-field>
            <van-field :label="$t('提款银行卡')" class="cell-item mt-2">
              <template #input>
                <div class="d-flex flex-full text-white">
                  <van-radio-group v-model="formObj.bankCardId">
                    <van-radio class="bank-item"
                               v-for="(item, index) in cardList"
                               :key="index"
                               :name="item.id"
                    >{{ item.cardType }} -
                      {{
                        item.bankAccount || item.bankAccount1 || item.bankAccount2 || item.usdt
                      }}
                    </van-radio>
                  </van-radio-group>
                </div>
                <el-button
                    v-if="cardList.length<parseInt(paramMapAll['USER_BANK_CARD_LIMIT'])"
                    size="mini"
                    @click="$emit('close');jump('/user/profile?option=userBankCard')"
                >{{ $t('去设置') }}
                </el-button>
              </template>
            </van-field>
            <van-field  :label="$t('交易币种')" class="cell-item mt-2">
              <template #input>
                <div class="d-flex flex-full text-white">
                  <el-select v-model="formObj.coinCode" class="full-width">
                    <el-option
                        v-for="item in payoutChannels"
                        :key="item.coinCode"
                        :value="item.coinCode"
                        :label="item.coinCode"
                    />
                  </el-select>
                </div>
              </template>
            </van-field>
          </div>
        </div>
      </div>

      <h6 class="subtitle">{{ $t("提现金额") }}</h6>
      <van-form ref="withdrawForm" @submit="withdraw">
        <!-- 允许输入正整数，调起纯数字键盘 -->
        <van-field
            v-model="formObj.amount"
            :placeholder="$t('提款金额')"
            :rules="[
            {
              required: true,
              message: $t('Can_not_be_null'),
              trigger: 'blur'
            },
            {
              pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
              message: $t('Money_Error'),
              trigger: 'blur'
            }
          ]"
            autocomplete="off"
            type="number"
        />
        <van-field
            v-model="formObj.tkPassword"
            :placeholder="$t('提款密码')"
            :rules="[
            {
              required: true,
              message: $t('please_input_withdraw_password')
            },
            {
              pattern: /^.{4,16}$/,
              message: $t('withdraw_password_format_error'),
              trigger: 'blur'
            }
          ]"
            type="password"
        />
        <div style="margin: 16px;">
          <van-button
              :loading="loading"
              :loading-text="$t('submitting')"
              native-type="submit"
              block
              round
              small
              type="primary"
          >
            {{ $t("submit") }}
          </van-button>
        </div>
      </van-form>
      <template v-if="formObj.type === 'BALANCE'">
        <h6 class="subtitle">
          {{ $t("Fee") }}：
          <template v-if="userLevel.withdrawFeeMoney > 0">{{ getFee }}</template>
          <template v-else>{{ getFee }} ({{ getFeeRate }}%)</template>
        </h6>
      </template>
      <h6 v-if="paramMapAll['SYSTEM_VERSION'] !== 'D06'" class="subtitle mt-1">
        {{ $t("实际到账") }}：{{ formatMoney(getMoney, payoutChannel && payoutChannel.coinCode) }}
      </h6>
      <div class="text-red" style="padding: 10px;">
        {{ paramMapAll["WITHDRAW_TIPS"] }}
      </div>
    </div>
  </PopModal>
</template>
<script>
import PopModal from "@/components/PopModal.vue";
import {listToMap} from "@/utils/collUtil";
import {getList} from "@/api/user.bankCard";
import {commit} from "@/api/user.withdraw";

export default {
  name: 'WithdrawModal',
  components: {
    PopModal
  },

  computed: {
    ...Vuex.mapGetters([
      "currency",
      "userInfo",
      "userMoney",
      "userLevel",
      "paramMapAll"
    ]),
    balance() {
      return this.formObj.type === 'COMMISSION' ? this.userMoney.balance2 : this.userMoney.balance
    },
    getMoney() {
      return (this.formObj.amount - this.getFee) * (this.payoutChannel && this.payoutChannel.exchangeRate || 1)
    },
    getFee() {
      let isFee = this.getIsFee
      if (isFee) {
        if (this.userLevel.withdrawFeeMoney > 0) {
          return this.userLevel.withdrawFeeMoney
        }
        return this.formObj.amount && (this.formObj.amount * this.getFeeRate / 100) || 0
      }
      return 0
    },
    getFeeRate() {
      return this.getIsFee && this.userLevel.withdrawFee || 0
    },
    getIsFee() {
      let isFee = false
      // 本月次数
      if (this.userLevel.getWithdrawFreeMonthTimes > 0 && this.monthTimes >= this.userLevel.getWithdrawFreeMonthTimes) {
        isFee = true
      }
      if (!isFee && this.userMoney.todayTkTimes >= this.userLevel.withdrawFreeTimes) {
        isFee = true
      }
      return isFee
    },
    payoutChannel() {
      return this.formObj.coinCode && this.payoutChannels[this.formObj.coinCode]
    },
    accountTypes() {
      let types = (this.paramMapAll['WITHDRAW_ACCOUNT_TYPES'] || 'BALANCE,COMMISSION').split(',');
      if (this.paramMapAll["WITHDRAW_BALANCE_OPEN"] !== "1") {
        types = types.filter(item => item !==  'BALANCE');
      }
      return types.map(t => this.accountTypeMap[t])
    },
  },
  watch: {
    '$route'() {
      this.$store.dispatch("user/getUserMoney")
    }
  },
  data() {
    return {
      // types: ["COMMISSION","BALANCE"],
      cardList: [],
      formObj: {amount: null, bankCardId: null, type: null},
      loading: false,
      token: null,
      washMoneyOpen: false,
      accountTypeMap: {
        BALANCE: {code: 'BALANCE', label: '基础账户', value: false,},
        COMMISSION: {code: 'COMMISSION', label: '佣金账户', value: true,},
      },
      payoutChannels: [],
      showPayoutChannels: false,
    };
  },
  created() {
    this.washMoneyOpen = this.paramMapAll["WITHDRAW_WASH_OPEN"] === "1";
    if (this.accountTypes.length) {
      this.formObj.type = this.accountTypes[0].code
    }
    // if (this.paramMapAll["WITHDRAW_BALANCE_OPEN"] !== "1") {
    //   const index = this.types.indexOf("BALANCE");
    //   if (index > -1) {
    //     this.types.splice(index, 1);
    //   }
    // }
  },
  methods: {
    show() {
      this.$refs.modal.show();
      this.getToken();
      this.getPayoutChannels();
      this.getList();
    },
    async getToken() {
      this.token = (await this.$store.dispatch("common/getToken")).data;
    },
    async getPayoutChannels() {
      const channels = (await this.$post('/user/withdraw/getPayoutChannelList')).data
      this.payoutChannels = listToMap(channels, 'coinCode')
    },
    async getList() {
      const list = (await getList()).data || [];
      if (!list || list.length === 0) {
        this.$dialog
            .confirm({message: this.$t("Please_add_bank_first")})
            .then(() => {
              this.$router.push({path: `/user/profile`});
              // this.$router.push({ path: `/user/bankCard` });
            })
            .catch(() => {
              this.$refs.modal.hide();
            });
      }
      this.cardList = list;
      list.length && (this.formObj.bankCardId = list[0].id);
    },
    withdraw() {
      const type = this.formObj.type;
      if (!type) {
        this.$toast.fail(this.$t("withdrawType") + this.$t("Can_not_be_null"));
      }
      const balance =
          type === "BALANCE" ? this.userMoney.balance : this.userMoney.balance2;
      if (this.formObj.amount <= 0 || this.formObj.amount > balance) {
        this.$toast.fail(this.$t("withdraw_money_limit", {balance: balance}));
        return;
      }
      if (this.loading) return;
      this.loading = true;
      let limitTimes = this.userLevel.withdrawFreeTimes;
      if (this.userMoney.todayTkTimes >= limitTimes) {
        this.$dialog
            .confirm({
              message: this.$t("withdraw_times_limit", {
                todayWithdrawNum: this.userMoney.todayTkTimes,
                limitTimes: limitTimes,
                withdrawFee: this.userLevel.withdrawFee
              }),
              messageAlign: "left"
            })
            .then(() => {
              this.commit(this.formObj);
            })
            .catch(() => {
              this.loading = false;
            });
      } else {
        this.commit(this.formObj);
      }
    },
    filterWithdrawType(list) {
      const map = listToMap(list, 'code')
      // console.log('newList',newList)
      return (this.paramMap['WITHDRAW_ACCOUNT_TYPE'] || 'BALANCE').split(',').map(code => map[code])
    },
    async commit(userWithdraw) {
      userWithdraw["X-IDEMPOTENT-TOKEN"] = this.token;
      commit(userWithdraw)
          .then(() => {
            this.loading = false;
            this.todayWithdrawNum += 1;
            this.$store.dispatch("user/getUserInfo");
            this.$toast.success(this.$t("Commit_Success"));
            this.$router.back();
          })
          .catch(() => {
            this.loading = false;
          })
          .finally(async () => {
            this.token = (await this.$store.dispatch("common/getToken")).data;
          });
    }
  }
};
</script>
<style>
.justify-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.ft-26 {
  font-size: 40px;
}

.text-mute {
  opacity: 0.7;
}

.bank-item {
  border-bottom: 1px solid #efefef;
  //margin-bottom: 4px;
  padding: 8px 10px;
  border-radius: 10px;
}
</style>
